import { Typography, Box } from "@tiny/components";
import * as React from "react";

function CardDescription({
  description,
  disabled = false,
}: {
  description: string;
  disabled?: boolean;
}) {
  return (
    <Box mb={2} flex="1 1 100%">
      <Typography variant="body3" color="grey" tone={disabled ? 700 : 800}>
        {description}
      </Typography>
    </Box>
  );
}

export { CardDescription };
